import MinorInfo from "./MinorInfo";
import registrationStep from "../../../registrationStep";

export default registrationStep(MinorInfo, "minors");



// WEBPACK FOOTER //
// ./src/registration/components/Minors/MinorInfo/index.js